
import type { PropType } from 'vue'
import type { TimeSlotByDay } from '@/new-services/types/time-slots'

import { defineComponent, reactive } from 'vue'

import TimeSlotByDayResources from './TimeSlotByDayResources.vue'
import TimeSlotByDaySectors from './TimeSlotByDaySectors.vue'
import TimeSlotByDayChild from './TimeSlotByDayChild.vue'

export default defineComponent({
    components: {
        TimeSlotByDayResources,
        TimeSlotByDaySectors,
        TimeSlotByDayChild
    },
    props: {
        item: {
            type: Object as PropType<TimeSlotByDay>,
            required: true
        }
    },
    emits: ['change-status'],
    setup(props, { emit }) {
        const state = reactive({
            is_opened: false,
        })

        const toggle = () => state.is_opened = !state.is_opened
        const format = (timeStr: string) => timeStr.substring(0, 5)

        const onChangeStatus = () => emit('change-status', { timeSlotId: props.item.id, statusId: props.item.status.id })
        const onChangeStatusInChild = (payload: { timeSlotId: number; statusId: number; }) => emit('change-status', payload)

        const getPeriod = (periodStart: string, periodEnd: string) => {
            let periodEndHours = Number(periodEnd.split(':')[0])

            if (periodEndHours === 23) {
                return `${periodStart} — 00:00`
            }

            periodEndHours = periodEndHours + 1

            return `${periodStart} — ${periodEndHours.toString().padStart(2, '0')}:00`
        }

        return {
            state,
            toggle,
            format,
            getPeriod,
            onChangeStatus,
            onChangeStatusInChild
        }
    }
})
